<div class="fixed top-4 right-4 z-[99999] flex flex-col gap-3 w-96 pointer-events-none">
  @for (toast of toasts(); track trackById($index, toast)) {
    <div
      @slideIn
      class="pointer-events-auto w-full bg-white dark:bg-night-900 shadow-[0px_1px_3px_0px_rgba(16,24,40,0.10),0px_1px_2px_-1px_rgba(16,24,40,0.10)] dark:shadow-none border-l-[5px] flex flex-col overflow-hidden"
      [ngClass]="borderClass(toast.type)"
    >
      <!-- Content row -->
      <div class="px-4 pt-4 pb-3 relative flex flex-col gap-1.5">
        <div class="pr-6 flex items-center gap-2">
          <!-- Icon -->
          <svg
            class="w-5 h-5 flex-shrink-0"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            [ngClass]="{
              'stroke-success-600': toast.type === 'success',
              'stroke-destructive-600': toast.type === 'error',
              'stroke-warning-600': toast.type === 'warning'
            }"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="iconPath(toast.type)" />
          </svg>

          <!-- Title -->
          <p
            class="text-sm font-medium leading-6 font-sans"
            [ngClass]="textClass(toast.type)"
          >
            {{ toast.title }}
          </p>
        </div>

        <!-- Subtitle -->
        @if (toast.subtitle) {
          <p class="pl-7 text-xs text-neutral-500 dark:text-night-400 leading-5 font-sans">
            {{ toast.subtitle }}
          </p>
        }

        @if (toast.action) {
          <button
            type="button"
            class="pl-7 self-start text-xs font-semibold underline text-primary-600 hover:text-primary-700 dark:text-primary-400 transition-colors"
            (click)="runAction(toast)"
          >
            {{ toast.action.label }}
          </button>
        }

        <!-- Close button -->
        <button
          type="button"
          class="absolute top-3 right-3 w-5 h-5 flex items-center justify-center text-neutral-400 hover:text-neutral-600 dark:hover:text-night-200 transition-colors"
          (click)="dismiss(toast.id)"
          aria-label="Cerrar notificación"
        >
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Progress bar -->
      <div class="self-stretch h-[3px]" [ngClass]="barClass(toast.type)"></div>
    </div>
  }
</div>
